import { useEffect, useState } from 'react';
import Menu from './Menu';
import Button from './Button';
import Modal from './modals/Modal';
import Animal from './Animal';

const animals = [
    'armadillo',
    'bat',
    'coral',
    'crow',
    'lion',
    'dolphin',
    'donkey',
    'elephant',
    'frog',
    'hedgehog',
    'jellyfish',
    'kiwi',
    'koala',
    'mole',
    'monkey',
    'octopus',
    'crocodile',
    'ostrich',
    'owl',
    'panda',
    'parrot',
    'pig',
    'puffer',
    'wolf',
    'rabbit',
    'rat',
    'scorpion',
    'skunk',
    'snail',
    'whale',
    'zebra',
    'sheep',
    'snake',
]
const canvas = document.createElement("canvas");
const context = canvas.getContext("2d");

function getTextWidth(text) {
    context.font = "16px Inter";
    const width = context.measureText(text).width;
    return width;
}

function Login({ enterRoom, error, connected }) {
    const [name, setName] = useState('');
    const [showAnimalSelect, setShowAnimalSelect] = useState(false);
    const [animal, setAnimal] = useState(animals[Math.floor(Math.random()*animals.length)]);

    const chooseAnimal = (animal) => {
        // console.log('picked animal', animal)
        setAnimal(animal);
        setShowAnimalSelect(false);
    }

    const preloadAnimals = () => {
        animals.forEach(animal => {
            require('../assets/animals/' + animal + '.svg');
        })
    }

    const handleNameChange = (e) => {
        // only allow if the length doesnt exceed the max
        if (getTextWidth(e.target.value) < 115) {
            setName(e.target.value);
        }
    }

    useEffect(() => {
        preloadAnimals();
    }, []);

    return (
        <Menu>
            { error && <p className='text-red-400 rounded mb-4'>{error}</p> }
            <div className='flex gap-2 mb-3 items-end'>
                <div className='flex flex-col'>
                    <label htmlFor='natuno-name' className='text-sm text-neutral-200'>Name</label>
                    <input name='natuno-name' id='natuno-name' value={name} onChange={handleNameChange} className='w-full h-8 bg-neutral-200 text-black px-1 py-0.5 border border-gray-500 rounded' />
                </div>
                <Animal animal={animal} onClick={() => setShowAnimalSelect(true)}/>
            </div>
            { connected ? (
                <Button onClick={() => enterRoom(name, animal)} text={'Enter'} className={'w-full'}/>
            ) : (
                <Button onClick={null} text={'Connecting to server...'} className={'w-full text-[1rem] text-neutral-200'} styling="primary" disabled={true}/>
                // <p className='font-semibold text-teal-600'>Connecting to server...</p>
            )}
            { showAnimalSelect && <AnimalSelect setAnimal={chooseAnimal} />}
        </Menu>
    )
}

function AnimalSelect({ setAnimal }) {
    return (
        <Modal>
            <div className='pb-8 pt-72 sm:pt-0 sm:pb-0 sm:mx-10 grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-11 gap-2'>
                { animals.map((animal) => {
                    return (
                        <Animal animal={animal} onClick={() => setAnimal(animal)} className={'p-3'} key={animal}/>
                    )
                })}
            </div>
        </Modal>
    )
}

export default Login;